import styled from 'styled-components'
import { FlexContainer, Paragraph, device } from 'heliocor-ui'

const DetailsWrapper = styled(FlexContainer)`
    && {
        width: 100%;
        min-width: auto;
        align-items: center;
        justify-content: center;
        @media ${device.midSize}{
            min-width: 18.7rem;
            align-items: flex-start;
        }
    }
`

const DragAndDropBox = styled.div`
    width: 100%;
    @media ${device.midSize}{
        width: 20rem;
    }
`

const DetailsParagraph = styled(Paragraph)`
    max-width: 10rem;
    margin:.1rem 0;                                     
    overflow: hidden;
`

export {
    DetailsParagraph,
    DetailsWrapper,
    DragAndDropBox
}

